<script setup lang="ts">
// Authenticated app top bar — search slot, user menu (doc 04 §9.1).
import { useAuthStore } from '@/stores/auth.store'
import { useRouter } from 'vue-router'

const auth = useAuthStore()
const router = useRouter()

async function signOut() {
  await auth.logout()
  void router.push({ name: 'home' })
}
</script>

<template>
  <v-app-bar color="secondary" flat>
    <v-app-bar-title>
      <RouterLink to="/app/dashboard" class="text-white text-decoration-none cpa-display">
        CPA
      </RouterLink>
    </v-app-bar-title>
    <v-spacer />
    <v-btn icon="mdi-bell-outline" color="white" variant="text" />
    <v-menu>
      <template #activator="{ props }">
        <v-btn v-bind="props" icon="mdi-account-circle" color="white" variant="text" />
      </template>
      <v-list>
        <v-list-item to="/app/dashboard" title="Dashboard" />
        <v-list-item title="Sign out" @click="signOut" />
      </v-list>
    </v-menu>
  </v-app-bar>
</template>
